import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import router from './router'
import { createStore } from 'vuex'
import store from './store'
import axios from 'axios'
import '@/assets/icons'

import SvgIcon from '@/components/SvgIcon/index.vue';

import WebSocketComponent from '@/components/WebSocketComponent/WebSocketComponent.vue'; 


axios.defaults.baseURL = "/sougou" //

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: zhCn,
})
app.component('SvgIcon', SvgIcon)
app.component('web-socket', WebSocketComponent);
app.use(store).use(router).mount('#app')

